import { Expose, Type } from "class-transformer";
import { IsBoolean, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
import SelectItem from "@/models/components/inputs/selectItem";
import { FormOfPaymentItem } from "@/models/api/FormOfPaymentItem";

export class OrderGetTemporaryOrderSectionCurrencyItem {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  name!: string;
  @IsString()
  @Expose()
  code!: string;
  @IsBoolean()
  @Expose()
  autoUpdate!: boolean;
}

export class SectionBankAccountItem {
  @IsNumber()
  @Expose()
  bankAccountId!: number;
  @IsString()
  @Expose()
  bankName!: string;
  @IsString()
  @Expose()
  accountNumber!: string;
  @IsString()
  @Expose()
  swift!: string;
  @IsString()
  @Expose()
  currency!: string;

  static ToSelectItem = (sectionBankAccountItem: SectionBankAccountItem): SelectItem => {
    return {
      text:
        sectionBankAccountItem.bankName +
        " " +
        sectionBankAccountItem.accountNumber +
        " " +
        sectionBankAccountItem.swift +
        " " +
        sectionBankAccountItem.currency,
      value: sectionBankAccountItem.bankAccountId,
    } as SelectItem;
  };
}

export class OrderGetTemporaryOrderSection {
  @IsString()
  @Expose()
  issueDate!: string;
  @IsString()
  @Expose()
  saleDate!: string;
  @IsString()
  @Expose()
  paymentDate!: string;
  @IsOptional()
  @IsString()
  @Expose()
  currencyCode!: string;
  @IsOptional()
  @IsNumber()
  @Expose()
  bankAccountId!: number | null;
  @IsNumber()
  @Expose()
  formOfPaymentId!: number;
  @IsBoolean()
  @Expose()
  isFromSaleDate!: boolean;
  @IsBoolean()
  @Expose()
  isCorrection!: boolean;
  @IsBoolean()
  @Expose()
  isFormalCorrection!: boolean;
  @IsOptional()
  @IsString()
  @Expose()
  projectId!: string | null;
  @IsOptional()
  @IsNumber()
  @Expose()
  documentType!: number | null;

  @Type(() => OrderGetTemporaryOrderSectionCurrencyItem)
  @ValidateNested()
  @Expose()
  currencies!: Array<OrderGetTemporaryOrderSectionCurrencyItem>;

  @Type(() => SectionBankAccountItem)
  @ValidateNested()
  @Expose()
  bankAccounts!: Array<SectionBankAccountItem>;

  @Type(() => FormOfPaymentItem)
  @ValidateNested()
  @Expose()
  formOfPayments!: Array<FormOfPaymentItem>;
}
